import React, { useState } from "react";
import { X } from "lucide-react";

const EarlyAccessModal = ({ isOpen, onClose }) => {
  const [googleFormData, setGoogleFormData] = useState({});

  const deploymentId =
    "AKfycbwih6Pcae62ya_zE4c7QXGUJfwX1PowYkvOx1LVFgrMZu8YxbZCcyHKk6gpNVkq9ZcWDw";
  const WEB_APP_URL =
    "https://script.google.com/macros/s/AKfycbwih6Pcae62ya_zE4c7QXGUJfwX1PowYkvOx1LVFgrMZu8YxbZCcyHKk6gpNVkq9ZcWDw/exec";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    role: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit1 = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Replace with your Formspree form ID
      const response = await fetch("https://formspree.io/f/xvgzrpoy", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus("success");
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
          setFormData({ name: "", email: "", company: "", role: "" });
        }, 2000);
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  if (!isOpen) return null;

  // Replace form submission with this
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    console.log("Form data:", formData);
    console.log("calling early access form API");


    try {
      const response = await fetch(WEB_APP_URL, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        setSubmitStatus("success");
        setTimeout(() => {
          onClose();
          setFormData({ name: "", email: "", company: "", role: "" });
        }, 2000);
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      style={{
        fontFamily: "Inter",
        fontSize: "18px",
        color: "#4C4D5E",
      }}
    >
      <div className="bg-white rounded-lg w-full max-w-md relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>

        {/* Modal content */}
        <div className="p-6">
          <h2 className="text-2xl font-semibold text-[#0E0444] mb-4">
            Sign Up for Early Access
          </h2>
          <p
            className="mb-6"
            style={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: "28px",
              letterSpacing: "-0.025em",
              color: "#0E0444",
            }}
          >
            Join our beta testing program and be among the first to experience
            ZetaFlow.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="name"
                className="mb-1"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                Full Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 rounded-md border border-gray-300 bg-gray-100"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="mb-1"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                Email Address *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 rounded-md border border-gray-300 bg-gray-100"
              />
            </div>

            <div>
              <label
                htmlFor="company"
                className="mb-1"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                Company Name
              </label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                className="w-full px-4 rounded-md border border-gray-300 bg-gray-100"
              />
            </div>

            <div>
              <label
                htmlFor="role"
                className="mb-1"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                Role
              </label>
              <select
                id="role"
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="w-full px-4 rounded-md border border-gray-300 bg-gray-100"
                style={{
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 600,
                  lineHeight: "22px",
                  letterSpacing: "-0.0125em",
                  color: "#4C4D5E",
                }}
              >
                <option value="">Select your role</option>
                <option value="executive">Executive</option>
                <option value="manager">Manager</option>
                <option value="developer">Developer</option>
                <option value="other">Other</option>
              </select>
            </div>

            <button
              type="submit"
              style={{
                fontFamily: "Inter",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "20px",
                letterSpacing: "-0.0125em",
                color: "#FFFFFF",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                outline: "none",
                border: "none",
                borderRadius: "4px",
                padding: "0.8rem 1.6rem",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "box-shadow 0.3s ease",
                transform: isSubmitting ? "translateY(4px)" : "translateY(0px)",
              }}
              disabled={isSubmitting}
              className="w-full bg-[#0C60F2] text-white py-2 rounded-md hover:bg-blue-700 transition-colors disabled:bg-blue-300"
            >
              {isSubmitting ? "Submitting..." : "Join Beta Program"}
            </button>

            {submitStatus === "success" && (
              <p className="text-green-600 text-center">
                Successfully registered! Thank you.
              </p>
            )}
            {submitStatus === "error" && (
              <p className="text-red-600 text-center">
                Something went wrong. Please try again.
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default EarlyAccessModal;
